// extracted by mini-css-extract-plugin
export default {"oil-selection":"OilSelection_oil-selection__STCbk","dropdown":"OilSelection_dropdown__gpRKV","open":"OilSelection_open__iT2IP"};